module.exports = __webpack_public_path__ + "img/117ne.31f6fe7e.svg";